'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { useSessionMonitor } from '@/utilities/useSessionMonitor'
import { installPatientLinkSessionGuard } from '@/utilities/auth/patientLinkSessionGuard'
import { IMPERSONATION_TOKEN_TYPE } from '@/utilities/stytch/useImpersonationAuth'
import { isClientPortal } from '@/utilities/stytch/config'
import { isGoogleOAuthPopupPath, SHARED_PATHS } from '@/utilities/paths'

function isImpersonationAuthenticate(pathname: string): boolean {
  if (pathname !== SHARED_PATHS.authenticate || typeof window === 'undefined') {
    return false
  }

  return (
    new URLSearchParams(window.location.search).get('stytch_token_type') ===
    IMPERSONATION_TOKEN_TYPE
  )
}

function ActiveSessionMonitor({ redirectTo, pathname }: { redirectTo: string; pathname: string }) {
  useSessionMonitor({
    redirectTo,
    enabled: !isImpersonationAuthenticate(pathname),
  })
  useEffect(() => {
    if (isClientPortal()) return
    return installPatientLinkSessionGuard()
  }, [])
  return null
}

export const SessionMonitor = ({ redirectTo = '/login' }: { redirectTo?: string }) => {
  const pathname = usePathname()
  // Popup pages close quickly and have no session to monitor. Skip Stytch hooks
  // so the SDK does not fetch RBAC and then abort when the window closes.
  if (pathname === SHARED_PATHS.logout || isGoogleOAuthPopupPath(pathname)) {
    return null
  }

  return <ActiveSessionMonitor redirectTo={redirectTo} pathname={pathname} />
}
